import { AppUsers } from "@/models/AppUsers";
import { DataSafe } from "@/models/DataSafe";
import { SystemToDo } from "@/models/SystemToDo";
import { myDataSyncXMLHTTPRequests }from "@/services/DataSyncRequests";

export class DataSync{

    static async sendNewDataToServer(myToDoRows: any){
        //console.log(myToDoRows)
        return await AppUsers.getMyUser().then((user) => {
            return DataSafe.getAllValuesWithAttributeNames(user.sysId,'noOtherDate').then((res) => {
                //console.log('vals from datasafe')
                // all myIds with 0 ServerId + values -> needs server insert
                let toHandle = Object.keys(myToDoRows);
                let sendToServerRows = [];
                let myKnownServerIds = [];
                let handledToDoRows = [];
                for(var i = 0; i < res.length; i++){
                    let row = res[i];
                    if(row.appUser == user.sysId){
                        if(row.serverId > 0){
                            myKnownServerIds.push({serverId: row.serverId, serverIdUpdateTS: row.serverIdUpdateTS, id: row.id});
                        }
                        /*@ts-ignore*/
                        let idToString = row["id"].toString()
                        /*@ts-ignore*/
                        if(toHandle.includes(idToString)){
                            let todoWords = [];
                            let todoIds = [];
                            /*@ts-ignore*/
                            for(var t=0;t<myToDoRows[row["id"]].length;t++){
                                /*@ts-ignore*/
                                todoWords.push(myToDoRows[row["id"]][t]["what"]);
                                /*@ts-ignore*/
                                todoIds.push(myToDoRows[row["id"]][t]["id"]);
                                /*@ts-ignore*/
                                handledToDoRows.push(myToDoRows[row["id"]][t]["id"]);
                            }
                            /*@ts-ignore*/
                            row["todo"] = todoWords;
                            /*@ts-ignore*/
                            row["todoId"] = todoIds;
                            //console.log(row)
                            sendToServerRows.push(row);
                        }
                    }
                }


                // controll unhadled ToDoRows
                for(var t= 0; t<toHandle.length;t++){
                    let ToDoRowsRaw = myToDoRows[toHandle[t]]
                    let todoWords = [];
                    let todoIds = [];
                    for(var tt=0;tt<ToDoRowsRaw.length;tt++){ 
                        let ToDoRowRaw=ToDoRowsRaw[tt]
                        
                        if(!handledToDoRows.includes(ToDoRowRaw.id)){
                           // console.log(ToDoRowRaw)
                            let help = {};
                            /*@ts-ignore*/
                            help["todoId"] = []
                            /*@ts-ignore*/
                            help["todoId"].push(ToDoRowRaw.id);
                            /*@ts-ignore*/
                            help["todo"] = []
                            /*@ts-ignore*/
                            help["todo"].push(ToDoRowRaw.what);
                            
                            if(ToDoRowRaw.what == 'deleteRowOnServer'){
                                /*@ts-ignore*/
                                help["serverId"] = ToDoRowRaw.with;
                                sendToServerRows.push(help);
                            }
                           // console.log(help)


                        }
                    }
                    
                }

              //  console.log(sendToServerRows)
                console.log('datasync prepared vals start now serversync')
    //            if((sendToServerRows.length > 0) || (myKnownServerIds.length > 0)){
                    return myDataSyncXMLHTTPRequests.sendToMyServer(sendToServerRows,myKnownServerIds).then((serverres: any) => {
                        console.log('response from sendToMyServer')
                        //console.log(serverres)
                        if(serverres == null)console.log('null return')
                        let ServerResult = JSON.parse(serverres);
                        //console.log(ServerResult.errors)
                        return DataSync.updateMyData(ServerResult.result,user.sysId,myToDoRows);
                    }).catch((error) => {
                        return error
                    });
                    
        //        }
            })
        })
    }


    static async updateMyData(serverResult: any,userid: string,myToDoRows: any){
        console.log('datasync update data with server-response')
        if(typeof serverResult == 'undefined')return false;
        let results = {
        }

        if(serverResult.length > 0){
            let forinsertOrUpdateCompleteDataRow = [];
            let forDeletes = [];
            let deletedServerDuplicates = [];
            for(var s=0; s < serverResult.length; s++){
                let Row = serverResult[s];
                //console.log(Row)
                /*@ts-ignore*/
                if(typeof results[Row.serverDone] == 'undefined')results[Row.serverDone] = 0;
                /*@ts-ignore*/
                results[Row.serverDone]++;
                switch(Row.serverDone){
                    /** trough myTodo: */
                    case 'insert':
                    case 'update':
                        //console.log(Row)
                        // here: only update serverId & serverIdUpdateTS
                        DataSafe.updateServerIdTStoId(Row.id,Row.serverId,Row.serverIdUpdateTS).then(() => {
                            //console.log(Row.todoId.length)
                            //console.log(Row)
                            for(var i = 0; i < Row.todoId.length; i++){
                                SystemToDo.deleteToDo(Row.todoId[i]); 
                            }
                        })
                        break;
                    /** newer / other data on server: */
                    case 'needsNewInsert':
                    case 'needsUpdate':
                        forinsertOrUpdateCompleteDataRow.push(Row);
                        break;
                    case 'needsDelete':
                        //console.log(Row)
                        forDeletes.push(Row.id)
                        //DataSafe.deleteRow(Row.id);
                        break;
                    case 'deleted':
                    case 'deleted_not_found':
                        for(var i = 0; i < Row.todoId.length; i++){
                            //console.log(Row.todoId[i])
                            SystemToDo.deleteToDo(Row.todoId[i]); 
                        }
                        break;
                    case 'deletedServerDuplicate':
                        deletedServerDuplicates.push(Row.serverId)
                        break;
                }
            }

            if(deletedServerDuplicates.length > 0){
                DataSafe.deleteToServerIds(userid,deletedServerDuplicates);
            }

            if(forinsertOrUpdateCompleteDataRow.length > 0){
                DataSafe.insertOrUpdateCompleteDataRow(userid,forinsertOrUpdateCompleteDataRow);
            }
            if(forDeletes.length > 0){
                for(var d=0;d<forDeletes.length;d++){
                    DataSafe.deleteRow(forDeletes[d]);
                }
                
            }
            SystemToDo.cleanUpMyToDoRows(myToDoRows);
        }
        
        return results;
    }
}